import { render, staticRenderFns } from "./PayDistributionModal.vue?vue&type=template&id=6b591f3c&scoped=true"
import script from "./PayDistributionModal.vue?vue&type=script&lang=js"
export * from "./PayDistributionModal.vue?vue&type=script&lang=js"
import style0 from "./PayDistributionModal.vue?vue&type=style&index=0&id=6b591f3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b591f3c",
  null
  
)

export default component.exports